import { render, staticRenderFns } from "./AddCardDialog.vue?vue&type=template&id=6f6d46a2&scoped=true"
import script from "./AddCardDialog.vue?vue&type=script&lang=js"
export * from "./AddCardDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCardDialog.vue?vue&type=style&index=0&id=6f6d46a2&lang=scss"
import style1 from "./AddCardDialog.vue?vue&type=style&index=1&id=6f6d46a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6d46a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6d46a2')) {
      api.createRecord('6f6d46a2', component.options)
    } else {
      api.reload('6f6d46a2', component.options)
    }
    module.hot.accept("./AddCardDialog.vue?vue&type=template&id=6f6d46a2&scoped=true", function () {
      api.rerender('6f6d46a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/identify/dialog/AddCardDialog.vue"
export default component.exports